var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEpLogoMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2046 2021.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 492.7,
    y1: 1288.48,
    x2: 994.03,
    y2: 572.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#09ff83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#21ff8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#49ff97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64ffa0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 909.56,
    y1: 1652.9,
    x2: 1410.88,
    y2: 936.94,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 1278.75 999.02 1278.75 999.02 971.05 819.2 971.05 819.2 1098.93 368.68 1098.93 819.2 522.27 819.2 743.27 710.47 743.27 569.98 923.1 999.02 923.1 999.02 0 0 1278.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1046.98 743.27 1046.98 2021.34 1226.8 1791.89 1226.8 923.1 1677.32 923.1 1539.95 1098.93 1274.75 1098.93 1274.75 1278.75 1627.66 1278.75 2046 743.27 1046.98 743.27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpLogoMain);
export default __webpack_public_path__ + "static/media/ep-logo-main.1a1a9d43ca1bd6b0674f5540f042342d.svg";
export { ForwardRef as ReactComponent };